<template>
  <div>
  <template >

    <div >
   
      <!-- 7.6修改 -->
      <!-- 首页不同颜色卡片显示 -->
      <div class="home-content">
        <div class="flex-content">
          <div class="color-box bg-primary" @click="toMyInventoryCustomer()">
            <div style="display:flex;align-items:center;justify-content: space-between;">
              <div>
                <i class="el-icon-collection" style="font-size:40px;"></i>
              </div>
              <div>
                <h2>{{homePageData.DtProducts}}</h2>
              </div>
            </div>
            <div class="card-text">My products</div>
          </div>
          <div class="color-box bg-warning" @click="toOrderList()">
            <div style="display:flex;align-items:center;justify-content: space-between;">
              <div>
                <i class="el-icon-document-checked" style="font-size:40px;"></i>
              </div>
              <div>
                <h2>{{homePageData.DtOrders}}</h2>
              </div>
            </div>
            <div class="card-text">Shipped Orders</div>
          </div>
          <div class="color-box bg-success" @click="toMyPaidDetail">
            <div style="display:flex;align-items:center;justify-content: space-between;">
              <div>
                <i class="el-icon-money" style="font-size:40px;"></i>
              </div>
              <div>
                <h2
                  
                >{{Me && Me.Account?Me.Account.realBalance+ '('+ (Me.Account.Currency.EnName)+ ')':'0'}}</h2>
              </div>
            </div>
            <div class="card-text">Account Balance</div>
            <!-- {{gets('$余额')}}:{{Me.Account.realBalance+ '('+ (Me.Account.Currency.EnName)+ ')'}} -->
          </div>
          <div class="color-box bg-danger" @click="toSupportTicket" v-if="showhelp==false">
            <div style="display:flex;align-items:center;justify-content: space-between;">
              <div>
                <i class="el-icon-service" style="font-size:40px;"></i>
              </div>
              <div>
                <h2>{{Question && Question.Records?Question.Records.length:'0'}}</h2>
              </div>
            </div>
            <div class="card-text">Support Ticket</div>
          </div>
            <div class="color-box bg-danger" @click="toMyQusetion" v-else>
              <div style="display:flex;align-items:center;justify-content: space-between;">
                <div>
                  <i class="el-icon-service" style="font-size:40px;"></i>
                </div>
                <div>
                  <h2>{{Question && Question.Records?Question.Records.length:'0'}}</h2>
                </div>
              </div>
              <div class="card-text">Support Ticket</div>
            </div>
        </div>
      </div>
      <!-- 首页不同颜色卡片显示结束 -->

      



    </div>
    <!-- echarts图标显示 -->
    <div style="display: flex;justify-content: space-around;" >
      <div class="card" >
        <div class="card-title" style="position:relative;font-weight:bold;font-size:20px">Sales</div>
        <div style="display:flex;justify-content: center;">
          <div style="width:800px;height:480px; "  ref="chart" id="echarts1"></div>
        </div>
        
      </div>
      <div class="card" >
        <div class="card-title" style="position:relative;margin-bottom:30px;font-weight:bold;font-size:20px">Products</div>
        <div style="display:flex;justify-content: center;">
          <div style="width:600px;height:500px;"  ref="chart2" id="echarts2"></div>
        </div>
      </div>
    </div>


    <!-- 新闻公告显示开始 -->
      <div class="app-container" style="display:none">
        <el-row :gutter="12" >
          <el-col>
            <el-card class="box-card1">
              <div slot="header" class="clearfix">
                <span style="font-size:18px"> <i class="el-icon-bell" style="margin-right:10px;color:#409EFF;font-size:19px;"></i>{{g('$新闻/公告')}}</span>
                <el-button
                  style="float: right; padding: 3px 0"
                  type="text"
                  @click="toSearchSys_New()"
                >{{g('$刷新')}}</el-button>
              </div>
              <div v-for="o in SearchSys_New" :key="o.ID" class="text item clearfix">
                <a @click="ToNew(o.ID)" style="float: left;"> <span class="dot"></span> {{o.Title}}</a>
                <span style="float: right;">{{o.OperatorTime}}</span>
              </div>
            </el-card>
          </el-col>

        </el-row>
      </div>
      <!-- 新闻公告显示结束 -->
    </template>

  </div>
</template>

<script>
import { userRequest } from "@/request/user";
const echarts = require("echarts");
import {
  IsRights,
  Modulel,
  Permission,
  Clone,
  ToComponentData,
  CheckByConfig,
  ToSubmitData
} from "@/config/config";
import gets from "@/model/language";
import bus from "@/model/bus";
import { Sys_NewRequest } from "@/request/Sys_New";
      import {
        QuestionRequest
    } from '@/request/Question'
import orderList from '@/frame/Order/OrderList'    
export default {
  data() {
    return {
      ModalName: gets("$"),
      SearchSys_New: [],
      showhelp: true,
      routes: [],
      window: window,
      openWindows: [],
      thisWindow: null,
      routes: [],
      Index: 1,
      Me: null,
      homePageData:{},
      $Urlpath: window._$Urlpath,
      Urlpath: window._$Urlpath,

      PurNotice: 0,
      OrderNotice: 0,
      xAxis: [], //折线图x轴数据
      lineChart:[],//折线图的日期和对应的值
      QuantityDeliver:[],//折线图显示的值
      userID:'',//用户ID
      Question:{},//工单接口返回的数据
      QuestionArr:[],//工单列表数组

      ballCharts:[],//饼状图数据
      ballChartsStatus:"",
      ballChartsNum:"",
      
      array:[
              {
                  name:gets('$草稿'),
                  value:0,
                  status:0,
              },
              {
              
                   name:gets('$确认'),
                  value:0,
                  status:1,
              },
              {
                
                   name:gets('$处理中'),
                  value:0,
                  status:7,
              },
              {
                 
                   name:gets('$已发货'),
                  value:0,
                  status:4,
              },
              {
                
                   name:gets('$缺货'),
                  value:0,
                  status:6,
              },
              {
                  
                   name:gets('$问题件'),
                  value:0,
                  status:5,
              },
      ],
    };
  },
  components:{
    orderList
  },
   created() {
    
    //  let c = {
    //               name: gets('$订单列表'),
    //               tag: 'OrderList',
    //               url: '/OrderList',
    //               moduleID: 27
    //           };
    //           let i={
    //             isShow: false,
    //             name: gets('$订单列表'),
    //               twoNavs: [{
    //                     name: gets('$订单列表'),
    //                     tag: 'OrderList',
    //                     url: '/OrderList',
    //                     moduleID: 27
    //                 },]
    //           }
    //     this.openNav(i,c)
   
    //bus.$emit("onChart")
       if(this.UserContext.UserType!=1){
     
           return
       }
    this.init();
    self = this;
    userRequest.GetMyUser(function(d) {
      if (!d.Message) {
        self.$set(self.$data, "Me", d);
        self.userID = self.Me.ID
        //请求首页数据
        userRequest.HomepageQueryData(function(d) {

          if (!d.Message) {
            self.$set(self.$data, "homePageData", d);
            self.lineChart = self.homePageData.ListLatestWeek//折线图数据
            self.ballCharts = self.homePageData.listOrdrSum//饼状图数据

            // let status = ["草稿","确认","待付款","待收货","已发货","问题件","缺货","处理中","","预报中","已作废"]
            
          
                self.ballCharts.forEach(function(val, index, arr){
              
                  let index2 = self.array.findIndex(el=>el.status == val.name)
                 
                  if(index2>-1){
                    self.array[index2].value = val.value
                  }
	                
                 
               });
              
              
              self.lineChart.forEach(function(val, index, arr){
                self.xAxis.unshift(val.DateTime)
                
                self.QuantityDeliver.unshift(val.QuantityDeliver)
                
              });
               self.initCharts();
               self.initCharts2(self.array);
          }
         
          },self.userID);
          
          //获取工单列表数据
          QuestionRequest.SearchQuestion(function(d) {
            if (!d.Message) {
              self.$set(self.$data, "Question", d);    
              //self.Question.Records.length=7
                
            }
          },{ID:self.userID});



        }
    });
      
   


  },
  computed: {
    UserContext() {
      return window.rootVue.$store.state.UserRights.UserContext;
    },
    d() {
      window.rootVue = this;
      if (self.UserContext && self.UserContext.UserType != 0) {
        return this.$store.state.CustomerNavs;
      }
      return this.$store.state.Navs;
    }
  },

  mounted() {
    
       if(this.UserContext.UserType!=1){
     
           return
       }
    this.initCharts();
    this.initCharts2();
    
  },

  methods: {
   
        async toSupportTicket(){
          //self.$message.error(self.gets("$抱歉，此模块正在开发中"))
          bus.$emit("Question")
        },
        async toMyQusetion(){
          //self.$message.error(self.gets("$抱歉，此模块正在开发中"))
          bus.$emit("MyQuestion")
        },
        async toMyInventoryCustomer(){
           bus.$emit("MyInventoryCustomer")
        },
        async toOrderList(){
          
           bus.$emit("onChart")
        },
        async toMyPaidDetail(){
           bus.$emit("MyPaidDetail")
        },
        setLastWindowByNav(NavTag) {
          let self = this
        if (self.$route.params && self.thisWindow && self.thisWindow.params) {
          for (var hh in self.$route.params) {
            self.thisWindow.params[hh] = self.$route.params[hh];
          }
        }
        if (!self.getLastWindowByNav(NavTag)) {
          return;
        }
        self.$set(self.$data, 'thisWindow', self.getLastWindowByNav(NavTag))
        if (self.getLastWindowByNav(NavTag).params) {
          for (var hh in self.getLastWindowByNav(NavTag).params) {
            self.$route.params[hh] = self.getLastWindowByNav(NavTag).params[hh];
          }
        }
      },
    openNav() {
      
     
      window.rootVue = this;
      let c = {
            name: "Order list",
            tag: "Order",
            url: "/Order",
      };
      this.$set(this.d, "thisNav", c);
      this.d.openNavs.push(c);
      this.openWindows.push(c);
     //  this.setLastWindowByNav(c.tag);
    //  this.$set(this.d, "openNavs", this.d.openNavs);
     // this.$router.push(c.url);
      // var is = this.d.openNavs.find(e => e.url == c.url);
      // if (!is) {
      //   this.$set(this.d, "thisNav", c);
      //   this.d.openNavs.push(c);
      //   //this.openWindows.push(c)
      //   self.setLastWindowByNav(c.tag);
      //   this.$set(this.d, "openNavs", this.d.openNavs);
      //   this.$router.push(c.url);
      // } else {
      //   self.closeNav(c);
      //   window.setTimeout(function() {
      //     self.openNav(i, c);
      //   }, 100);
      // }
      // this.$set(i, "isShow", false);
    },
    initCharts() {
      let myChart = echarts.init(this.$refs.chart);
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            // let tip = params[0].name;
            let tip = "";
            // var date = newDate()

            var currentDate = new Date();
            var timesStamp = currentDate.getTime();
            var currenDay = currentDate.getDay();
            var dates = [];
            for (var i = 0; i < 7; i++) {
              dates.push(
                new Date(
                  timesStamp + 24 * 60 * 60 * 1000 * (i - ((currenDay + 6) % 7))
                )
                  .toLocaleDateString()
                  .replace(/\//g, "-")
              );
            }

            for (let i = 0; i < params.length; i++) {
              //tip+='orders: '+params[i].value+'<br>'+'Date:'+dates[params[i].dataIndex]+'<br>';
              tip +=
                "orders: " +
                params[i].value +
                "<br>" +
                "Date:" +
                params[0].name +
                "<br>";
             
            }
            
            return tip;
          }
        },
        xAxis: {
          type: "category",
          data: this.xAxis,
          axisLabel: {
                interval:0,//代表显示所有x轴标签显示
            }
        },
        yAxis: {
          type: "value"
        },
        grid:{
          width:'600px'
        },
        series: [
          {
            data:this.QuantityDeliver,
            type: "line"
          }
        ]
      })
    
    },

    initCharts2() {
     
      let myChart = echarts.init(this.$refs.chart2);
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },

        legend: {
          orient: "vertical",
          left: 10,
          data: [gets('$草稿'),gets('$确认'),gets('$处理中'),gets('$已发货'),gets('$缺货'),gets('$问题件')]
          // ["草稿","确认","待付款","待收货","已发货","问题件","缺货","处理中","","预报中","已作废"]
        },
        series: [
          {
            name:gets('$订单状态'),
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "30",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false
            },
            data:this.array,
            // data:[
            //   {value: 335, name: '草稿'},
            // ]
          }
        ]
      });

      myChart.on("click",async e => {
        //self.$message.error(self.gets("$抱歉，此模块正在开发中"))
        
        //bus.$emit("onChart")
      });
    },

    init() {
      window.rootVue.setThisWindowVueComponent(this);
      var self = this;
      self.toSearchSys_New();

      if (self.UserContext.UserType == 0) {
        self.showhelp = false;
      }
    },
    toSearchSys_New() {
      var self = this;
      Sys_NewRequest.SearchSys_New(
        function(d) {
          self.$set(self.$data, "SearchSys_New", d.Records);
        },
        {
          PageSize: 6,
          Status: 1,
          SeeTypeArr: self.UserContext.UserType == 0 ? [0, 2] : [0, 1]
        }
      );
    },

    step1() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[2],
        self.$store.state.CustomerNavs.navs[2].twoNavs[0]
      );
    },
    step2() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[0],
        self.$store.state.CustomerNavs.navs[0].twoNavs[2]
      );
    },
    step3() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[2],
        self.$store.state.CustomerNavs.navs[2].twoNavs[2]
      );
    },
    step4() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[1],
        self.$store.state.CustomerNavs.navs[1].twoNavs[0]
      );
    },
    step5() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[1],
        self.$store.state.CustomerNavs.navs[1].twoNavs[2]
      );
    },
    step6() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[0],
        self.$store.state.CustomerNavs.navs[0].twoNavs[0]
      );
    },
    step7() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[0],
        self.$store.state.CustomerNavs.navs[0].twoNavs[1]
      );
    },
    step8() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[3],
        self.$store.state.CustomerNavs.navs[3].twoNavs[1]
      );
    },
    step9() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[5],
        self.$store.state.CustomerNavs.navs[5].twoNavs[0]
      );
    },
    gets: gets,
    g: gets,
    ToNew(ID) {
      window.open("#/New/" + ID);
    }
  }
};

</script>
<style>

@media screen and (max-width: 2600px) {
    .color-box{
      width: 31rem !important;
      height: 10.5rem !important;
      margin: 4.8rem 3.6rem !important;
      margin-top: 5rem !important;
    }
    .home-content h2{
      font-size: 35px;
    }
    .flex-content i{
      font-size: 50px !important;
    }
    .card-text{
      font-size: 20px;
    }

     #echarts1{
      width: 1000px !important;
      height: 550px !important;
    } 
      #echarts2{
      width: 700px !important;
      height: 600px !important;
    } 
}
 @media screen and (max-width: 2000px){
   .color-box {
     margin: 3.2rem 2.6rem !important;
      margin-top: 3rem !important;
      height: 7.6rem !important;
    }
    .card{
      margin-bottom: 0px !important;
      margin-top: 10px !important;
      padding-bottom: 0px !important;
    }
     .home-content h2{
      font-size: 22px;
    }
    .card-text{
      font-size: 14px;
    }
    #echarts1{
      width: 800px !important;
      height: 480px !important;
    } 
     #echarts2{
      width: 600px !important;
      height: 500px !important;
    } 
}
 @media screen and (max-width: 1745px){
   .color-box {
      margin: 2.8rem 2.6rem !important;
      margin-top: 3rem !important;
      height: 7.6rem !important;
    }
  
   
}
#echarts1 div:nth-child(1),#echarts2 div:nth-child(1){
  width: 100% !important;
  height: 100% !important;
}
#echarts1 canvas{
  width: 100% !important;
  height: 100% !important;
}
#echarts2 canvas{
  width: 100% !important;
  height: 100% !important;
}
.dot{
  width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #4680FF;
    display: inline-block;
    margin-right: 5px;
}

.card {
  background: #ffffff;
  margin: 30px 0;
  padding: 12px;
  border: 0 solid rgba(120, 130, 140, 0.13);
  border-radius: 5px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  width: 45%;
  padding: 30px 30px;
}
.flex-content {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.card-text {
  text-align: right;
}
.color-box {
  width: 24rem;
  height: 8rem;
  cursor: pointer;
  background: #ffffff;
  margin: 3.8rem 2.6rem;
  margin-top: 4rem;
  padding: 0.96rem;
  border: 0 solid rgba(120, 130, 140, 0.13);
  border-radius: 0.36rem;
  box-shadow: 0 0.36rem 1.6rem rgba(0, 0, 0, 0.05);
}
.bg-primary {
  background-color: #4680ff;
  color: #ffffff;
  fill: #4680ff;
}
.bg-warning {
  background-color: #ffc107;
  color: #ffffff;
  fill: #ffc107;
}
.bg-success {
  background-color: #4caf50;
  color: #ffffff;
  fill: #4caf50;
}
.bg-danger {
  background-color: #ff5722;
  color: #ffffff;
  fill: #ff5722;
}

.text {
  font-size: 14px;
}
.item {
  /* margin-bottom: 18px; */
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f2f2f2;
  cursor: pointer;
}
.item:hover{
  background-color: #F5F7FA;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.box-card1 {
  width: 47%;
  margin-top: 50px;
  margin: auto;
}
.home-list-notice {
  float: left;
  width: 20%;
  height: 100px;
  /* background-color:rgb(56, 121, 237); */
  background-color: #009aff;
  text-align: center;
  padding: 10px;
  margin-left: 20px;
}
.arrows-space {
  width: 20%;
}
@media screen and (max-width: 1400px) {
  .home-list-notice {
    float: left;
    width: 26%;
    height: 105px;
    background-color: rgb(56, 121, 237);
    text-align: center;
    padding: 10px;
    margin-left: 20px;
  }
  .arrows-space {
    width: 26%;
  }
}
</style>



// WEBPACK FOOTER //
// StoreAnalysis.vue?f2787998